window.CleanupAddRevenueAttribution = function() {

	var addRevenueCookieNames;
	var addRevenueLocalStorageKeys;
	var shouldClear;

	function InitValues() {
		var flags = window.ContentBaseAffiliateFlags ?? {};

		addRevenueCookieNames      = flags.addRevenueCookieNames ?? [];
		addRevenueLocalStorageKeys = flags.addRevenueLocalStorageKeys ?? [];
		shouldClear                = (flags.clearAddRevenueAttribution === true);
	}

	function ClearCookie(cookieName) {
		document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
		document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure`;
	}

	function ClearCookies() {
		// Browser-side cookie cleanup is a backup; AddRevenue localStorage cleanup is the main reason this helper exists.
		addRevenueCookieNames.forEach((cookieName) => {
			ClearCookie(cookieName);
		});
	}

	function ClearLocalStorage() {
		// AddRevenue stores attribution in localStorage too, which the server cannot clear.
		addRevenueLocalStorageKeys.forEach((storageKey) => {
			localStorage.removeItem(storageKey);
		});
	}

	function Cleanup() {
		if (shouldClear) {
			ClearCookies();
			ClearLocalStorage();
		}
	}

	function CleanupSafely() {
		try {
			InitValues();
			Cleanup();
		} catch (e) {
			console.log(e);
		}
	}

	CleanupSafely();
}

window.CleanupAddRevenueAttribution();
